export enum Country {
    US = 'US',
    GB = 'GB',
    IE = 'IE',
    FR = 'FR',
    DE = 'DE'
}
